module.exports = __webpack_public_path__ + "static/media/vehicle-type-car-white.89181be6.svg";